import moment from "moment";
import { DATE_TIME_FORMATS } from "../../../data/constants";

export const TRANSACTION_TYPE_MAP: any = {
  "1": {
    typeId: "1",
    name: "Transfer-In",
    val: "Transfer In",
  },
  "2": {
    typeId: "2",
    name: "Transfer-Out",
    val: "Transfer Out",
  },
  "3": {
    typeId: "3",
    name: "Expenses",
    val: "Expense",
  },
};

export const REASON_DATA_MAP: any = {
  "1": { name: "Groceries purchase", reasonId: "1" },
  "2": { name: "Fruits & Vegetable purchase", reasonId: "2" },
  "3": { name: "Meat Purchase", reasonId: "3" },
  "4": { name: "Electrician", reasonId: "4" },
  "5": { name: "Plumbing service", reasonId: "5" },
  "6": { name: "Pest control", reasonId: "6" },
  "7": { name: "Tip Amount", reasonId: "7" },
  "8": { name: "Others", reasonId: "8" },
};

export const CASH_TABLE_HEADER:any = [
  {
    id: 1,
    name: "All Transactions",
    val: "all"
  },
  {
    id: 2,
    name: "Expenses",
    val: "Expense"
  },
  {
    id: 3,
    name: "Transfer-In",
    val: "Transfer In"
  },
  {
    id: 4,
    name: "Transfer-Out",
    val: "Transfer Out"
  },
];

export const UPOADED_SUCCESSFULLY = "Uploaded Successfully !";
export const ATTACHMENT_DELETED   = "Attachment has been deleted";
export const EDIT_SUCCESS         = "Edited Successfully !";
export const FILE_UPLOAD_ERROR    = "File size should be less than 500KB";

export const TRANSACTION_TYPE     = {
  all: "all",
  transferIn: "Transfer In",
  transferOut: "Transfer Out",
  expense: "Expense"
};

export const CURRENT_DATE = moment().format(DATE_TIME_FORMATS.dayMonthYear);
export const CASHIER_FEATURE = ["DAILY_CLOSING", "CASH_REGISTER"];
export const USER_ROLE = 'User'